export interface NotifyField {
  label: string
  value: string | number | undefined | null
}

export interface NotifyFormPayload {
  formType: string
  source?: string
  fields: NotifyField[]
}

/**
 * Sends a form submission notification to info@healic.in.
 * Fire-and-forget; never throws to the caller (logs to console on failure).
 */
export async function notifyForm(payload: NotifyFormPayload): Promise<boolean> {
  try {
    const body = {
      formType: payload.formType,
      source: payload.source ?? '',
      fields: payload.fields
        .filter((f) => f.label)
        .map((f) => ({
          label: f.label,
          value:
            f.value === undefined || f.value === null ? '' : String(f.value),
        })),
    }
    const res = await fetch('/api/public/notify-form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    if (!res.ok) {
      console.error('notifyForm failed', res.status, await res.text())
      return false
    }
    return true
  } catch (err) {
    console.error('notifyForm error', err)
    return false
  }
}
